/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { faHome, faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../components/button/Button';
import { Tooltip } from '../../components/tooltip/Tooltip';

const SHOW_TOOLTIP_MAX_RESOLUTION = 900;
const MAX_LIBRARY_LABEL_LENGTH = 11;

type TopNavLibraryItemProps = {
  activeTabLabel: string;
  isMiddleBarVisible: boolean;
  changeMiddleBarVisibility: () => void;
};

export function TopNavLibraryItem({
  activeTabLabel,
  isMiddleBarVisible,
  changeMiddleBarVisibility,
}: TopNavLibraryItemProps) {
  const { t } = useTranslation();
  const libraryLabel = t('nav.pages.library').toUpperCase();

  const path = window.location.pathname;
  const navigate = useNavigate();

  const isForYouPage = path.includes('for-you');
  const isLibraryPage =
    path.includes('for-you') ||
    path.includes('library') ||
    path.includes('results') ||
    path.includes('challenge');

  const cutIfLongerThan = (text: string, maxLength: number) => {
    if (text.length > maxLength) {
      return `${text.slice(0, maxLength)}...`;
    }
    return text;
  };

  return (
    <Tooltip content={libraryLabel} maxResolution={SHOW_TOOLTIP_MAX_RESOLUTION}>
      <div className={`top-nav-bar-item library-item ${isForYouPage ? 'for-you-page-active' : ''}`}>
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!isLibraryPage) {
              navigate('/for-you/library');
            }
          }}
          className={`top-nav-bar-button ${isLibraryPage ? 'active' : 'non-active cursor-pointer'}`}
        >
          <FontAwesomeIcon icon={faHome} size="lg" />
        </div>

        {isLibraryPage ? (
          <p className="library-nav-item-text-container no-cursor-actions active">
            <span className="visuallyHidden">{t('nav.page.selectedPage')}</span>
            <span>{libraryLabel}</span>
            <span className="library-nav-item-subtext" aria-hidden="true">
              {cutIfLongerThan(activeTabLabel, MAX_LIBRARY_LABEL_LENGTH)}
            </span>
            <span className="sr-only">{activeTabLabel}</span>
          </p>
        ) : (
          <a
            href="/library/for-you"
            className="library-nav-item-text-container non-active"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!isLibraryPage) {
                navigate('/for-you/library');
              }
            }}
          >
            <span className="">{libraryLabel}</span>
            <span className="library-nav-item-subtext" aria-hidden="true">
              {cutIfLongerThan(activeTabLabel, MAX_LIBRARY_LABEL_LENGTH)}
            </span>
            <span className="sr-only">{activeTabLabel}</span>
          </a>
        )}

        <Button
          ariaLabel={
            isMiddleBarVisible
              ? t('nav.page.healthAreasNavigationOpen')
              : t('nav.page.healthAreasNavigationClosed')
          }
          ariaPressed={isMiddleBarVisible}
          ariaExpanded={isMiddleBarVisible}
          ariaControls="health-areas-navigation"
          isDecorative={isForYouPage}
          onClick={isForYouPage ? () => {} : changeMiddleBarVisibility}
          icon={{
            color: isForYouPage ? 'gray' : 'white',
            faIconDefinition: faChevronDown,
            size: 'lg',
            className: `rotate-icon ${isMiddleBarVisible ? 'rotate-icon-rotated' : ''}`,
          }}
          variant="ghost"
          className={`library-nav-arrow-button ${isForYouPage ? 'no-cursor-actions null-opacity' : ''}`}
        />
      </div>
    </Tooltip>
  );
}
